import { render, staticRenderFns } from "./Vendors.vue?vue&type=template&id=620eff6a&scoped=true"
import script from "./Vendors.vue?vue&type=script&lang=ts"
export * from "./Vendors.vue?vue&type=script&lang=ts"
import style0 from "./Vendors.vue?vue&type=style&index=0&id=620eff6a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620eff6a",
  null
  
)

export default component.exports